import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';
import { colors } from '../../../theme/colors';

const CONTENT_WIDTH = 248;

export const References: FunctionComponent = () => (
  <View style={styles.container}>
    <Text style={styles.text}>
      [1] Drossman DA, Hasler WL. Rome IV—Functional GI Disorders: Disorders of Gut-Brain
      Interaction. Gastroenterology. 2016;150(6):1257-1261.
      doi:https://doi.org/10.1053/j.gastro.2016.03.035. [2] Peters, S., et al., Randomised clinical
      trial: the efficacy of gut-directed hypnotherapy is similar to that of the low FODMAP diet for
      the treatment of irritable bowel syndrome. Alimentary pharmacology & therapeutics, 2016.
      44(5): p. 447-459. [3] Peters S, Gibson PR, Halmos EP. Smartphone app-delivered gut-directed
      hypnotherapy improves symptoms of self-reported irritable bowel syndrome: A retrospective
      evaluation. Neurogastroenterology and Motility. 2023;35(4).
      doi:https://doi.org/10.1111/nmo.14533. [4] Peters S, Gibson PR, Halmos EP. S515 App-Delivered
      Gut-Directed Hypnotherapy Program Nerva Improves Symptoms in Patients With Irritable Bowel
      Syndrome but How Can We Ensure Users Are Compliant? The American Journal of Gastroenterology.
      2022;117(10S):e365-e366. doi:https://doi.org/10.14309/01.ajg.0000858700.31768.51
    </Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    width: CONTENT_WIDTH,
  },
  text: {
    fontSize: 4,
    lineHeight: 1,
    letterSpacing: -0.2,
    color: colors.mutedGray,
  },
});
